<app-expandable-card [initiallyOpen]="true">
  <app-row class="px-3">
    <app-col xs="12">
      <app-inquiry-status-badge
        class="badge"
        [status]="inquiry.status"
        [offers]="numberOfOffers$ | async"
      />
      <app-card-title>
        @if (inquiry.created) {
          <span class="mr-3">
            {{ inquiry.created | date: 'shortDate' }}
          </span>
        }
        @if (location$ | async; as location) {
          <span class="mr-3">
            {{ location.label }}
          </span>
        }
        <span class="mr-3">
          {{ mapTypeToLabel(inquiry.type) }}
        </span>
        @if (inquiry.preferredContractDuration !== null) {
          <span class="mr-3">
            {{
              convertPreferredContractDuration(
                inquiry.preferredContractDuration
              )
            }}
          </span>
        }
      </app-card-title>
    </app-col>
  </app-row>

  <div content class="mouseflow-ignore">
    <app-row class="px-3">
      <app-col class="d-flex align-center">
        <app-round-icon class="mr-2 icon">access_time</app-round-icon>
        Angelegt&nbsp;
        @if (user$ | async; as user) {
          <span> von {{ user.firstname }} {{ user.lastname }}&nbsp; </span>
        }
        um {{ inquiry.created | date: 'shortTime' }}
      </app-col>

      @if (inquiry.quotationDeadline) {
        <app-col class="d-flex align-center">
          <app-round-icon class="mr-2 icon">access_alarm</app-round-icon>
          Gültig bis: {{ inquiry.quotationDeadline | date: 'shortDate' }}
        </app-col>
      }
    </app-row>

    <app-row class="px-3">
      @if (inquiry.transportByProducer === false) {
        <app-col class="d-flex align-center">
          <app-round-icon class="mr-2 icon">local_shipping</app-round-icon>
          <ng-container> Transport benötigt </ng-container>
        </app-col>
      }

      @if (inquiry.transportByProducer === true) {
        <app-col class="d-flex align-center">
          <app-round-icon class="mr-2 icon">trolley</app-round-icon>
          <ng-container> Kunde übernimmt Anlieferung </ng-container>
        </app-col>
      }
    </app-row>

    <app-row class="mt-3 px-3">
      @if (hasUnansweredQnas === true) {
        <app-col class="d-flex align-center">
          <app-round-icon class="mr-2 icon" style="color: red"
            >help</app-round-icon
          >
          <span style="color: red"> Unbeantwortete Fragen des Entsorgers </span>
        </app-col>
      }
    </app-row>

    @if (
      inquiry.preferredContractDuration !== null &&
      inquiry.preferredContractDuration !== 'P0Y'
    ) {
      <app-row class="px-3">
        <app-col class="d-flex align-center">
          <app-round-icon class="mr-2 icon">history_edu</app-round-icon>
          Ausgeschriebene Vertragslaufzeit:
          {{
            convertPreferredContractDuration(inquiry.preferredContractDuration)
          }}
        </app-col>
      </app-row>
    }

    <app-row class="px-3">
      <app-col class="d-flex align-center">
        <app-waste-pills [inquiryElements]="inquiry.inquiryElements" />
      </app-col>
    </app-row>

    <app-row class="mt-3 px-3">
      @if (inquiry.status === 'OPEN' || inquiry.status === 'VERIFIED') {
        <app-col>
          <button
            (click)="removeInquiry(inquiry.id)"
            mat-button
            color="primary"
          >
            Zurückziehen
          </button>
        </app-col>
      }

      @if (inquiry.status === 'DRAFT') {
        <app-col>
          <button
            (click)="removeInquiry(inquiry.id)"
            mat-button
            color="primary"
          >
            Löschen
          </button>
        </app-col>
      }

      <app-spacer></app-spacer>

      <app-col>
        @if (inquiry.status === 'OPEN' || inquiry.status === 'VERIFIED') {
          <a
            [routerLink]="['/neue-entsorgungsanfrage', 'neu', inquiry.id]"
            mat-stroked-button
            color="primary"
          >
            Duplizieren
          </a>
        }
      </app-col>

      @if (inquiry.quotationDeadline !== null) {
        <app-col>
          @if (inquiry.status === 'OPEN' || inquiry.status === 'VERIFIED') {
            <button
              (click)="extendInquiryDeadline()"
              mat-stroked-button
              color="primary"
            >
              Verlängern
            </button>
          }
        </app-col>
      }

      <app-col>
        <button
          (click)="showInquiryDetails(inquiry.id)"
          mat-stroked-button
          color="primary"
        >
          Details anzeigen
        </button>
      </app-col>

      @if (inquiry.status === 'DRAFT') {
        <app-col>
          <a
            [routerLink]="['/neue-entsorgungsanfrage', 0, 2, inquiry.id]"
            mat-raised-button
            color="primary"
          >
            Bearbeiten
          </a>
        </app-col>
      }

      @if (numberOfOffers$ | async; as numberOfOffers) {
        <app-col>
          <button
            mat-raised-button
            color="primary"
            [routerLink]="'/erzeuger-angebote/' + inquiry.id"
          >
            {{
              numberOfOffers
                | i18nPlural: { '=1': '# Angebot', other: '# Angebote' }
            }}
            ansehen
          </button>
        </app-col>
      }
    </app-row>
  </div>
</app-expandable-card>
